// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/bg_youshi.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/BakbakOne-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  overflow: hidden;
}
* {
  margin: 0;
  padding: 0;
}
.anchorBL {
  display: none;
}
.main {
  width: 100%;
  height: 4.92188rem;
  position: relative;
  
}
.carousel {
  position: relative;
  width: 100%;
  height: 4.92188rem;
  overflow: hidden;
}
.carousel-list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4.92188rem;
  margin: 0;
  padding: 0;
  list-style: none;
}
.carousel-item {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  float: left;
  width: 100%;
  height: 4.92188rem;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  transition: opacity 1s ease-in-out;
}
.carousel-item.item1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.carousel-item.active {
  opacity: 1;
}

.carousel .dot {
  position: absolute;
  bottom: 0.67708rem;
  left: 50%;
  display: flex;
  transform: translate(-50%);
}
.carousel .dot-item {
  width: 0.08333rem;
  height: 0.08333rem;
  border-radius: 50%;
  margin-left: 0.10417rem;
  background-color: rgba(255, 255, 255, .3)
}
.carousel .dot-item.active {
  background-color: #fff;
}
.carousel-item-title {
  font-size: 0.29688rem;
  font-weight: 600;
  color: #fff;
  position: absolute;
  top: 1.82292rem;
  left: 1.5625rem;
}
.carousel-item-sub-title {
  font-size: 0.18229rem;
  font-weight: 400;
  color: rgba(255,255,255,.8);
  position: absolute;
  top: 2.34375rem;
  left: 1.5625rem;
}
@font-face {
  font-family: 'BakbakOne';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAW;EACX,UAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAa;EACb,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mDAA6C;EAC7C,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,WAAW;EACX,kBAAa;EACb,UAAU;EACV,kBAAkB;EAClB,OAAS;EACT,MAAQ;EACR,kCAAkC;AACpC;AACA;EACE,mDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAa;EACb,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,iBAAW;EACX,kBAAY;EACZ,kBAAkB;EAClB,uBAAiB;EACjB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAU;EACV,eAAW;AACb;AACA;EACE,qBAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAU;EACV,eAAW;AACb;AACA;EACE,wBAAwB;EACxB,4CAAgD;AAClD","sourcesContent":[".App {\n  text-align: center;\n  overflow: hidden;\n}\n* {\n  margin: 0px;\n  padding: 0px;\n}\n.anchorBL {\n  display: none;\n}\n.main {\n  width: 100%;\n  height: 945px;\n  position: relative;\n  \n}\n.carousel {\n  position: relative;\n  width: 100%;\n  height: 945px;\n  overflow: hidden;\n}\n.carousel-list {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 945px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.carousel-item {\n  background: url('./assets/images/banner.png');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  float: left;\n  width: 100%;\n  height: 945px;\n  opacity: 0;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  transition: opacity 1s ease-in-out;\n}\n.carousel-item.item1 {\n  background: url('./assets/images/bg_youshi.png');\n}\n\n.carousel-item.active {\n  opacity: 1;\n}\n\n.carousel .dot {\n  position: absolute;\n  bottom: 130px;\n  left: 50%;\n  display: flex;\n  transform: translate(-50%);\n}\n.carousel .dot-item {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-left: 20px;\n  background-color: rgba(255, 255, 255, .3)\n}\n.carousel .dot-item.active {\n  background-color: #fff;\n}\n.carousel-item-title {\n  font-size: 57px;\n  font-weight: 600;\n  color: #fff;\n  position: absolute;\n  top: 350px;\n  left: 300px;\n}\n.carousel-item-sub-title {\n  font-size: 35px;\n  font-weight: 400;\n  color: rgba(255,255,255,.8);\n  position: absolute;\n  top: 450px;\n  left: 300px;\n}\n@font-face {\n  font-family: 'BakbakOne';\n  src: url('./assets/fonts/BakbakOne-Regular.ttf');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
